import { action, makeObservable, observable } from 'mobx';
import { autoBetStore } from './autoBetStore';

export class ApplicationStore {
  accessToken = '';

  gameImages = [];

  isSoundsLoaded = false;

  isAuthenticated = false;

  isAuthDataReceived = false;

  isChangingCurrency = false;

  partnerSkin = 0;

  iconsInfo = [];

  showSkinLoader = false;

  isCardsGame = false;

  hasDepositPopup = false;

  isSocketConnected = false;

  isConnectionLost = false;

  isReconnect = false;

  isOverwriteMainCss = false;

  isOverwriteCoreCssLoaded = false;

  isOverwriteGameCssLoaded = false;

  isInitialResourceLoaded = false;

  gameCanvasTranslations = {};

  constructor() {
    makeObservable(this, {
      isCardsGame: observable,
      accessToken: observable,
      partnerSkin: observable,
      showSkinLoader: observable,
      isSoundsLoaded: observable,
      isAuthenticated: observable,
      hasDepositPopup: observable,
      isConnectionLost: observable,
      gameImages: observable,
      isReconnect: observable,
      iconsInfo: observable.deep,
      gameCanvasTranslations: observable,
      isSocketConnected: observable,
      isChangingCurrency: observable,
      isOverwriteMainCss: observable,
      isAuthDataReceived: observable,
      isOverwriteCoreCssLoaded: observable,
      isOverwriteGameCssLoaded: observable,
      isInitialResourceLoaded: observable,
      setIconsInfo: action.bound,
      setIsCardsGame: action.bound,
      setGameImages: action.bound,
      setPartnerSkin: action.bound,
      setShowSkinLoader: action.bound,
      setAccessToken: action.bound,
      setIsSoundsLoaded: action.bound,
      setIsAuthenticated: action.bound,
      setHasDepositPopup: action.bound,
      setGameCanvasTranslations: action.bound,
      setIsConnectionLost: action.bound,
      setIsSocketConnected: action.bound,
      setIsChangingCurrency: action.bound,
      setIsOverwriteMainCss: action.bound,
      setIsAuthDataReceived: action.bound,
      setIsOverwriteCoreCssLoaded: action.bound,
      setIsOverwriteGameCssLoaded: action.bound,
      setIsInitialResourceLoaded: action.bound,
    });
  }

  setIsOverwriteCoreCssLoaded(bool) {
    this.isOverwriteCoreCssLoaded = bool;
  }

  setIsChangingCurrency(bool) {
    this.isChangingCurrency = bool;
  }

  setIsOverwriteGameCssLoaded(bool) {
    this.isOverwriteGameCssLoaded = bool;
  }

  setIsOverwriteMainCss(bool) {
    this.isOverwriteMainCss = bool;
  }

  setHasDepositPopup(bool) {
    this.hasDepositPopup = bool;
  }

  setIsConnectionLost(bool) {
    if (bool) {
      autoBetStore.resetAutoBetState();
    }
    this.isConnectionLost = bool;
  }

  setIconsInfo(data) {
    this.iconsInfo = data;
  }

  setIsReconnect(bool) {
    if (bool) {
      autoBetStore.resetAutoBetState();
    }
    this.isReconnect = bool;
  }

  setIsSocketConnected(bool) {
    this.isSocketConnected = bool;
  }

  setIsCardsGame(bool) {
    this.isCardsGame = bool;
  }

  setGameImages(images) {
    this.gameImages = images;
  }

  setPartnerSkin(skin) {
    this.partnerSkin = skin;
  }

  setShowSkinLoader(bool) {
    this.showSkinLoader = bool;
  }

  setAccessToken(accessToken) {
    this.accessToken = accessToken;
  }

  setIsSoundsLoaded(bool) {
    this.isSoundsLoaded = bool;
  }

  setIsAuthenticated(isAuthenticated) {
    this.isAuthenticated = isAuthenticated;
  }

  setIsAuthDataReceived(isAuthDataReceived) {
    this.isAuthDataReceived = isAuthDataReceived;
  }

  setIsInitialResourceLoaded(bool) {
    this.isInitialResourceLoaded = bool;
  }

  setGameCanvasTranslations(data) {
    this.gameCanvasTranslations = data;
  }
}

export const applicationStore = new ApplicationStore();
